import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TokenBase, TokenMarket } from "~/types";

export interface TokenStore {
    token: {
        token_base: TokenBase;
        token_market: TokenMarket;
        share_type?: "order" | "token"
    };
}

const initialState: Partial<TokenStore> = { };

export const tokenSlice = createSlice({
    name: "token",
    initialState,
    reducers: {
        updateToken(state, action: PayloadAction<TokenStore['token']>) {
            state.token = action.payload;
        },
    },
});

export const {
    updateToken,
} = tokenSlice.actions;

export default tokenSlice.reducer;
